<button type="button" class="collapse-btn" mat-button (click)="toggleExpansion.emit()">
  @if (isWide()) {
    <mat-icon> arrow_left </mat-icon>
  } @else {
    <mat-icon>arrow_right</mat-icon>
  }
</button>
